import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import colors from 'vuetify/lib/util/colors'
// import Vuetify from 'vuetify/lib';
import Vuetify from 'vuetify'

Vue.use(Vuetify);
// import 'vuetify/dist/vuetify.min.css';

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    options: {
        customProperties: true
    },
    theme: {
        themes: {
            light: {
                primary: '#9734fa',
                secondary: '#b0bec5',
                accent: '#8c9eff',
                error: '#b71c1c',
                background: "#e0e0e0"
            },
        },
    },

});
